import { BidiModule } from "@angular/cdk/bidi";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzHighlightModule } from "ng-zorro-antd/core/highlight";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiTreeDropIndicatorComponent } from "@webapp/ui/tree/components/tree-drop-indicator/tree-drop-indicator.component";
import { UiTreeIndentComponent } from "@webapp/ui/tree/components/tree-indent/tree-indent.component";
import { UiTreeNodeBuiltinCheckboxComponent } from "@webapp/ui/tree/components/tree-node-checkbox/tree-node-checkbox.component";
import { UiTreeNodeSwitcherComponent } from "@webapp/ui/tree/components/tree-node-switcher/tree-node-switcher.component";
import { UiTreeNodeTitleComponent } from "@webapp/ui/tree/components/tree-node-title/tree-node-title.component";
import { UiTreeNodeBuiltinComponent } from "@webapp/ui/tree/components/tree-node/tree-node.component";
import { UiIconModule } from "../icon/icon.module";
import { UiTreeService } from "./services/tree.service";
import { UiTreeComponent } from "./tree.component";

@NgModule({
  imports: [CommonModule, ScrollingModule, BidiModule, NzHighlightModule, NzOutletModule, UiIconModule],
  providers: [UiTreeService],
  declarations: [
    UiTreeComponent,
    UiTreeIndentComponent,
    UiTreeDropIndicatorComponent,
    UiTreeNodeBuiltinComponent,
    UiTreeNodeBuiltinCheckboxComponent,
    UiTreeNodeSwitcherComponent,
    UiTreeNodeTitleComponent,
  ],
  exports: [UiTreeComponent, UiTreeIndentComponent, UiTreeNodeBuiltinComponent],
})
export class UiTreeModule {}
